<template>
  <div>
    <intersect @enter.once="playAnimation = true">
      <number
          ref="anim"
          animationPaused
          :from="0"
          :to="value"
          :duration="duration/1000"
      ></number>
    </intersect>
  </div>
</template>

<script>
import Intersect from 'vue-intersect'

export default {
  name: "Counter",
  components: {
    Intersect
  },
  data() {
    return {
      playAnimation: false
    }
  },
  props: {
    value: {
      type: Number,
      required: true
    },
    duration: {
      type: Number,
      required: true
    }
  },
  watch: {
    playAnimation: function(val) {
      if (val) {
        this.$refs.anim.play()
      }
    }
  }
}
</script>